import { render } from "./TheHeader.vue?vue&type=template&id=cd9c2230"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=cd9c2230&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__